import React from 'react';
import Header from '../../components/Header';

const Mens = () => {
    return (
        <div>
            <Header />
        </div>
    );
};

export default Mens;